module.exports = __webpack_public_path__ + "img/40.726a5917.png";